import { Eye, EyeOff } from "lucide-react";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
export default function SecurityForm({ isEditing }: any) {
  const {
    register,
     formState: { errors, touchedFields },
    setValue,
    trigger,
  } = useFormContext();

  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  useEffect(() => {
  if (!isEditing) {
    setShow1(false);
    setShow2(false);
    setShow3(false);
  }
}, [isEditing]);

  return (
    <div className="space-y-6">
      {/* Current Password */}
      <div>
        <label htmlFor="currentPassword" className="text-sm font-medium">Current Password</label>
        <div className="relative">
          <input
          id="currentPassword"
            type={show1 ? "text" : "password"}
            className="input"
            disabled={!isEditing}
            placeholder="Enter current password"
            {...register("currentPassword")}
            onChange={(e) => {
              setValue("currentPassword", e.target.value);
              if (touchedFields.currentPassword || errors.currentPassword) {
                trigger("currentPassword");
              }
               if (touchedFields.newPassword || errors.newPassword) {
          trigger("newPassword");
        }
            }}
            onBlur={() => trigger("currentPassword")}
          
            
          />

          <button
            type="button"
            disabled={!isEditing}
            
            className={`absolute right-3 top-1/2 -translate-y-1/2 ${
              isEditing ? "" : "opacity-40 cursor-not-allowed"
            }`}
            onClick={() => isEditing && setShow1(!show1)}
          >
            {show1 ? <Eye /> : <EyeOff />}
          </button>
        </div>
        {errors.currentPassword && (
          <p className="text-red-500 text-sm mt-1">
            {errors.currentPassword.message as string}
          </p>
        )}
      </div>

      {/* New Password */}
      <div>
        <label htmlFor="newPassword" className="text-sm font-medium">New Password</label>
        <div className="relative">
          <input
          id="newPassword"
            type={show2 ? "text" : "password"}
            className="input"
            {...register("newPassword")}
            disabled={!isEditing}
            placeholder="Enter new password"
            onChange={(e) => {
              setValue("newPassword", e.target.value);
              if (touchedFields.newPassword || errors.newPassword) {
                trigger("newPassword");
              }
              if (touchedFields.confirmPassword || errors.confirmPassword) {
                trigger("confirmPassword");
              }
               trigger("newPassword");
               
        if (touchedFields.confirmPassword || errors.confirmPassword) {
          trigger("confirmPassword");
        }
            }}
            onBlur={() => trigger("newPassword")}
          />
          <button
            type="button"
            disabled={!isEditing}
            className={`absolute right-3 top-1/2 -translate-y-1/2 ${
              isEditing ? "" : "opacity-40 cursor-not-allowed"
            }`}
            onClick={() => isEditing && setShow2(!show2)}
          >
            {show2 ? <Eye /> : <EyeOff />}
          </button>
        </div>
        {errors.newPassword && (
          <p className="text-red-500 text-sm mt-1">
            {errors.newPassword.message as string}
          </p>
        )}
      </div>

      {/* Confirm Password */}
      <div>
        <label htmlFor="confirmPassword" className="text-sm font-medium">Confirm Password</label>
        <div className="relative">
          <input
          id="confirmPassword"
            type={show3 ? "text" : "password"}
            className="input"
            {...register("confirmPassword")}
            disabled={!isEditing}
            placeholder="Confirm new password"
             onChange={(e) => {
              setValue("confirmPassword", e.target.value);
              if (touchedFields.confirmPassword || errors.confirmPassword) {
                trigger("confirmPassword");
              }
            }}
            onBlur={() => trigger("confirmPassword")}
          />
          <button
            type="button"
            disabled={!isEditing}
            className={`absolute right-3 top-1/2 -translate-y-1/2 ${
              isEditing ? "" : "opacity-40 cursor-not-allowed"
            }`}
            onClick={() => isEditing && setShow3(!show3)}
          >
            {show3 ? <Eye /> : <EyeOff />}
          </button>
        </div>
        {errors.confirmPassword && (
          <p className="text-red-500 text-sm mt-1">
            {errors.confirmPassword.message as string}
          </p>
        )}
      </div>
    </div>
  );
}
